// The kart game's developer switches, read off the page's address:
//   ?debug=1    the readout (fps, draw calls, the resolution step) and the
//               debug drawing: drift tiers on the road and the minimap, a
//               saved track or tuning raced over the real ones
//   ?look=old   the look from before the visual revamp (REVAMP_LOG.md), to
//               hold the new one up against

const param = (name: string) => {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch {
    return null;
  }
};

export const isDebugOn = () => param("debug") === "1";

/** Which look to draw: "new" unless the address asks for the old. */
export const LOOK: "old" | "new" = param("look") === "old" ? "old" : "new";
